import { useEffect, useState } from 'react'

export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

export const useDebounceWithLoading = <T>(
  value: T,
  delay: number,
): { debounced: T; debouncing: boolean } => {
  const [debounced, setDebouncedValue] = useState(value)
  const [debouncing, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedValue(value)
      setLoading(false)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay, debouncing])

  return { debounced, debouncing }
}
